import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceStatusService } from '../shared/services/device-status.service';
import { DeviceStatusViewBaseComponent } from '../shared/components/device-status-view-base.component';
import { ModbusService } from '@caslink/common-client/ng-app/modbus/ModbusService';
import { AppContextService } from '@caslink/common-client/ng-app/appContext/AppContextService';
import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { MenuItem } from '@captiveaire/table/lib/models/menuItem';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';
import { DeviceDetailViewMenuItem } from '../shared/services/device-menu-items.service';
import { DeviceLocationDeviceDetail } from '../shared/models/device-location-device-detail.interface';
import { KeyValue } from '@angular/common';
import * as _ from 'lodash';
import { DetailViewService } from '../shared/services/detail-view.service';
import { CellularDeviceActivationService } from '@caslink/common-client/ng-app/cellular-device-activation/cellular-device-activation.service';

interface DeviceCardControlMenuItem extends MenuItem {
    type: DeviceDetailViewMenuItem
}

@Component({
    selector: 'dl-device-card-controls',
    templateUrl: './device-card-controls.component.html',
    styleUrls: ['./device-card-controls.component.scss']
})
export class DeviceCardControlsComponent extends DeviceStatusViewBaseComponent implements OnInit {
    public static $name: string = 'deviceCardControls';

    @Input() device: DeviceLocationDeviceDetail;
    @Input() readerStatusView: boolean;
    @Output() readerStatusViewChange = new EventEmitter<boolean>();

    get viewMenuItem(): DeviceCardControlMenuItem {
        return this.detailViewService?.menuItems['viewDeviceDetail'];
    }

    oldHardwareVersion: number;

    constructor(
        public deviceStatusService: DeviceStatusService,
        public dialog: MatDialog,
        private modbusService: ModbusService,
        public appContextService: AppContextService,
        public dialogService: DialogService,
        public cellularDeviceActivationService: CellularDeviceActivationService,
        public detailViewService: DetailViewService
    ) {
        super();
    }

    ngOnInit() {
        this.oldHardwareVersion = this.currentItem?.hardwareVersion;
    }

    ngDoCheck() {
        if (this.currentItem?.hardwareVersion && this.currentItem.hardwareVersion !== this.oldHardwareVersion) {
            let newHardwareVersion = this.currentItem.hardwareVersion;
            this.modbusService.updateConfigurations(this.currentItem.macAddress, this.currentItem, this.currentItemState, newHardwareVersion);
            this.oldHardwareVersion = newHardwareVersion;
        }
    }

    getData(): angular.IPromise<any> {
        return this.detailViewService.getData();
    }

    editDeviceConfiguration(item: IDeviceStatusListSummary) {
        if (this.currentItem) {
            this.cancelEdit(this.currentItem);
        }
        item.$isInEditMode = true;
        this.currentItem = item;
        this.currentItemState = _.cloneDeep(item);
    }

    toggleReaderView($event) {
        $event.preventDefault();
        this.readerStatusView = !this.readerStatusView;
        this.readerStatusViewChange.emit(this.readerStatusView);
    }

    updateCellularDeviceStatus($event) {
        $event.preventDefault();
        this.cellularDeviceActivationService.updateCellularDeviceStatus(this.device.moduleId).then(
            response => {
                this.device.cellularDeviceStatus.isActive = response.isActive;
                this.device.cellularDeviceStatus.isConnected = response.isConnected;
                this.device.cellularDeviceStatus.activated = response.activated;
                this.device.cellularDeviceStatus.lastConnected = response.lastConnected;
                this.device.cellularDeviceStatus.lastDisconnected = response.lastDisconnected;
                this.device.cellularDeviceStatus.error = response.error;
            });
    }

    buttonHandler($event, menuItem: DeviceCardControlMenuItem) {
        if (menuItem.type) {
            switch (menuItem.type) {
                case DeviceDetailViewMenuItem.Save:
                    this.saveDevice($event);
                    break;
                case DeviceDetailViewMenuItem.Edit:
                    this.editDevice($event);
                    break;
                case DeviceDetailViewMenuItem.Cancel:
                    this.cancelDeviceEdit($event);
                    break;
            }
        } else if (menuItem.method) {
            menuItem.method($event, this.device);
        }
    }

    isVisible(menuItem: { isVisible: any }): boolean {
        return menuItem.isVisible(this.device);
    }

    showEditButton(menuItem: DeviceCardControlMenuItem): boolean {
        if (menuItem.type) {
            switch (menuItem.type) {
                case DeviceDetailViewMenuItem.Save:
                case DeviceDetailViewMenuItem.Cancel:
                    return true;
                default: return false;
            }
        }
        return false;
    }

    // Preserve original property order in ngfor
    originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return 0;
    }

    private editDevice($event) {
        $event.preventDefault();
        this.readerStatusView = false;
        this.editDeviceConfiguration(this.device);
    }

    private saveDevice($event) {
        $event.preventDefault();
        this.saveEdit(this.device);
    }

    private cancelDeviceEdit($event) {
        $event.preventDefault();
        this.cancelEdit(this.device);
    }

}
